import styled from 'styled-components';
import Container from '../Container/Container';

export const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.primaryColor};
`;

export const MontageContainer = styled(Container)`
  color: #fff;
  overflow-y: hidden;
  position: relative;
  height: 100vh;
`;

export const WallpaperPart = styled.div`
  @keyframes montage {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(100%);
    }
  }
  position: absolute;
  width: 20%;
  height: 100%;
  color: black;
  background-color: #fff;

  &.part1 {
    left: 0;
    border-right: 1px dashed ${({ theme }) => theme.colors.primaryColor};
    animation: montage 1s ease-in-out 0s 1 normal forwards;
    animation-play-state: paused;
    ${({ animPlay }) => (animPlay ? `animation-play-state: running;` : null)}
  }
  &.part2 {
    left: 20%;
    border-right: 1px dashed ${({ theme }) => theme.colors.primaryColor};
    animation: montage 1s ease-in-out 0.5s 1 normal forwards;
    animation-play-state: paused;
    ${({ animPlay }) => (animPlay ? `animation-play-state: running;` : null)}
  }
  &.part3 {
    left: 40%;
    border-right: 1px dashed ${({ theme }) => theme.colors.primaryColor};
    animation: montage 1s ease-in-out 1s 1 normal forwards;
    animation-play-state: paused;
    ${({ animPlay }) => (animPlay ? `animation-play-state: running;` : null)}
  }
  &.part4 {
    left: 60%;
    border-right: 1px dashed ${({ theme }) => theme.colors.primaryColor};
    animation: montage 1s ease-in-out 1.5s 1 normal forwards;
    animation-play-state: paused;
    ${({ animPlay }) => (animPlay ? `animation-play-state: running;` : null)}
  }
  &.part5 {
    left: 80%;
    animation: montage 1s ease-in-out 2s 1 normal forwards;
    animation-play-state: paused;
    ${({ animPlay }) => (animPlay ? `animation-play-state: running;` : null)}
  }
`;

export const Content = styled.div`
  opacity: 1;
  color: ${({ theme }) => theme.colors.light};
  display: flex;
  flex-direction: column;
  align-items: center;

  .head {
    font-size: 35px;
  }
  .cnt {
    font-size: 45px;
    font-weight: bold;
  }
  .last {
    margin-bottom: 24px;
  }
`;
